import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`About Me`}</h2>
    <p>{`Since my college days, I have been passionate about development and coding. I used to develop web applications and JavaScript games. I had a keen interest in how web and mobile applications works. I started exploring the tech stacks used to make these applications and my development journey started from here. I really enjoyed making creative applications and it became my passion.`}</p>
    <p>{`Currently I am employed as a Full-Stack Software Engineer. I have been developing production-ready web and mobile applications for more than 2 years now. I have worked on projects as a Full-Stack and Frontend Developer.`}</p>
    <br />
    <br />
    <br />
    <br />
    <h2>{`Skills`}</h2>
    <ul>
      <li parentName="ul">
        <h5 parentName="li">{`JavaScript`}</h5>
      </li>
      <li parentName="ul">
        <h5 parentName="li">{`Java`}</h5>
      </li>
      <li parentName="ul">
        <h5 parentName="li">{`ReactJS`}</h5>
      </li>
      <li parentName="ul">
        <h5 parentName="li">{`React Native`}</h5>
      </li>
      <li parentName="ul">
        <h5 parentName="li">{`NodeJS`}</h5>
      </li>
      <li parentName="ul">
        <h5 parentName="li">{`Express`}</h5>
      </li>
      <li parentName="ul">
        <h5 parentName="li">{`Nest JS`}</h5>
      </li>
      <li parentName="ul">
        <h5 parentName="li">{`Socket.io`}</h5>
      </li>
      <li parentName="ul">
        <h5 parentName="li">{`SQL`}</h5>
      </li>
      <li parentName="ul">
        <h5 parentName="li">{`MongoDB`}</h5>
      </li>
      <li parentName="ul">
        <h5 parentName="li">{`Firebase`}</h5>
      </li>
      <li parentName="ul">
        <h5 parentName="li">{`HTML5 Canvas`}</h5>
      </li>
      <li parentName="ul">
        <h5 parentName="li">{`Git`}</h5>
      </li>
      <li parentName="ul">
        <h5 parentName="li">{`Git-Hub`}</h5>
      </li>
      <li parentName="ul">
        <h5 parentName="li">{`JIRA`}</h5>
      </li>
      <li parentName="ul">
        <h5 parentName="li">{`Notion`}</h5>
      </li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      